// @ts-nocheck
import { isEqual } from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';

export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, (a, b) => isEqual(a, b));
